import React, { useState } from "react";
import moment from 'moment'
import { env } from '../../config'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import './Landing.css'
import axios from 'axios'
import {ONBOARDAPIURL} from '../../config'


const Landing = ({ appstate, isLoading, loginUser }) => {
  const [checkTerms, setCheckTerms] = useState(true);
  const [checkSharing, setCheckSharing] = useState(true);
  const [showUsernamePopup, setShowUsernamePopup] = useState(false);
  const [showSystemStatus, setShowSystemStatus] = useState(false);
  const [showRecoverySnackbar, setShowRecoverySnackbar] = useState(false);
  const [recoveryInfo, setRecoveryInfo] = useState({
    first_name: null,
    last_name: null,
    company_name: null,
    secondary_email: null,
  });

  const toggleUsernamePopup = () => {
    setShowUsernamePopup(!showUsernamePopup)
  }

  const handleRecoveryChange = (e) => {
    setRecoveryInfo({...recoveryInfo, [e.target.id]: e.target.value})
  }

  const handleRecoverySubmit = async() => {
    try{
        console.log(recoveryInfo)
        await axios.get(ONBOARDAPIURL+'/employee/recovery', {params: {secondary_email: recoveryInfo.secondary_email, first_name: recoveryInfo.first_name, last_name: recoveryInfo.last_name, company_name: recoveryInfo.company_name}})
    } catch(err){
        console.log(err)
    }

    toggleUsernamePopup()
    setShowRecoverySnackbar(true)
  }

  let bool = !!window.localStorage.getItem('Fw4_access_Token') && !moment().isAfter(moment(window.localStorage.getItem('Fw4_access_Token_exp')).add(-1, 'm')) && window.location.pathname !== "/"
  
  if (!bool) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundImage: 'url(./login_bg.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
        <Dialog open={showUsernamePopup} onClose={toggleUsernamePopup}>
          <DialogTitle>Username Recovery</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Enter your details below. You'll then receive an email if we match them with your account.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="secondary_email"
              label="Your Email"
              type="text"
              fullWidth
              variant="standard"
              onChange={handleRecoveryChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={toggleUsernamePopup}>Cancel</Button>
            <Button onClick={handleRecoverySubmit}>Submit</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={showSystemStatus}
          onClose={() => setShowSystemStatus(false)}
          fullWidth
          maxWidth="xs"
          aria-labelledby="system-status-title"
          PaperProps={{ className: 'system-status-dialog' }}
        >
          <DialogTitle id="system-status-title" className="system-status-title">
            <div>
              <span className="system-status-eyebrow">Fieldworker</span>
              <div>System Health</div>
            </div>
            <button
              type="button"
              className="system-status-close"
              onClick={() => setShowSystemStatus(false)}
              aria-label="Close system status"
            >
              &times;
            </button>
          </DialogTitle>
          <DialogContent>
            <div className="system-status-summary">
              <span className="system-status-dot" aria-hidden="true"></span>
              <div>
                <strong>All systems operational</strong>
                <span>Fieldworker services are running normally.</span>
              </div>
            </div>
            <div className="system-status-services">
              {[
                { name: 'Fieldworker Core API', description: 'Application services' },
                { name: 'Fieldworker Web Portal', description: 'Production web experience' },
                { name: 'Fieldworker Referral Hub', description: 'Referral coordination services' },
                { name: 'Fieldworker Data Platform', description: 'Secure production database' },
              ].map((service) => (
                <div className="system-status-service" key={service.name}>
                  <div>
                    <strong>{service.name}</strong>
                    <span>{service.description}</span>
                  </div>
                  <span className="system-status-badge">
                    <span className="system-status-dot" aria-hidden="true"></span>
                    Operational
                  </span>
                </div>
              ))}
            </div>
          </DialogContent>
          <DialogActions className="system-status-actions">
            <Button onClick={() => setShowSystemStatus(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* Top Navigation Bar */}
        <div style={{ 
          backgroundColor: 'white', 
          padding: '15px 40px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ fontSize: '24px', fontWeight: '600', color: '#333' }}>
            FieldWorker
          </div>
          <div style={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
            <a href="https://fieldworker.gitbook.io/fieldworker-docs" style={{ color: '#666', textDecoration: 'none', fontSize: '16px', fontWeight: '600' }}>Knowledge Base</a>
            <button 
              style={{ 
                border: '1px solid #ddd', 
                padding: '8px 20px', 
                borderRadius: '4px',
                backgroundColor: 'white',
                cursor: ((!!checkSharing && !!checkTerms && !isLoading) && appstate.signinBtn) ? 'pointer' : 'not-allowed',
                fontSize: '15px',
                fontWeight: '500',
                color: '#333',
                opacity: ((!!checkSharing && !!checkTerms && !isLoading) && appstate.signinBtn) ? 1 : 0.5
              }}
              disabled={((!!checkSharing && !!checkTerms && !isLoading) && appstate.signinBtn) ? false : true}
              onClick={loginUser}
            >Sign In</button>
          </div>
        </div>

        {/* Main Content - Two Columns */}
        <div style={{ 
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px 20px'
        }}>
          <div style={{ 
            display: 'flex',
            gap: '30px',
            maxWidth: '1200px',
            width: '100%',
            flexWrap: 'wrap'
          }}>
            {/* Left Column - Login Portal */}
            <div style={{ 
              backgroundColor: 'white',
              borderRadius: '12px',
              padding: '40px',
              paddingBottom: '25px',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              flex: 1,
              minWidth: '400px',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <div style={{ 
                textAlign: 'center', 
                marginBottom: '20px',
                background: 'linear-gradient(135deg, rgba(240, 240, 240, 0.2) 0%, rgba(192, 192, 192, 0.5) 50%, rgba(240, 240, 240, 0.2) 100%)',
                padding: '20px 20px',
                margin: '-40px -40px 20px -40px',
                borderRadius: '12px 12px 0 0'
              }}>
                <p style={{ color: '#666', fontSize: '16px', marginBottom: '10px', margin: 0 }}>Welcome to FieldWorker</p>
              </div>

              <h2 style={{ fontSize: '32px', fontWeight: '600', margin: '0 0 30px 0', color: '#333', textAlign: 'center' }}>Login Portal</h2>

              <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'center' }}>
                <button 
                  style={{
                    width: '100%',
                    maxWidth: '300px',
                    border: '1px solid #ddd',
                    padding: '12px',
                    borderRadius: '4px',
                    backgroundColor: 'white',
                    cursor: ((!!checkSharing && !!checkTerms && !isLoading) && appstate.signinBtn) ? 'pointer' : 'not-allowed',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    fontSize: '15px',
                    opacity: ((!!checkSharing && !!checkTerms && !isLoading) && appstate.signinBtn) ? 1 : 0.5
                  }}
                  disabled={((!!checkSharing && !!checkTerms && !isLoading) && appstate.signinBtn) ? false : true}
                  onClick={loginUser}
                >
                  {isLoading || appstate.signinBtn === false ? (
                    <div style={{ color: '#0b61e2' }} className="spinner-border spinner-border-sm" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    <>
                      <img style={{ width: '20px', height: '20px' }} src='./ms.png' alt='msIcon' />
                      <span style={{ fontSize: '18px' }}>Sign in with Microsoft</span>
                    </>
                  )}
                </button>
              </div>

              <div style={{ textAlign: 'center', fontSize: '13px', color: '#666', marginBottom: '10px' }}>
                By signing in, you agree to our <a href="https://fieldworker.ai/termsandconditions/" target="_blank" rel="noopener noreferrer" style={{ color: '#0b61e2', textDecoration: 'none' }}>terms and privacy policy</a>.
              </div>

              <button onClick={toggleUsernamePopup} style={{ color: '#0b61e2', textDecoration: 'none', display: 'block', border: 'none', background: 'none', cursor: 'pointer', padding: 0, font: 'inherit', margin: '0 auto 15px auto', fontSize: '13px' }}>
                Forgot username?
              </button>

              {/* Error Messages */}
              {appstate.modal && (
                <div style={{ 
                  backgroundColor: '#fff3cd', 
                  border: '1px solid #ffeeba',
                  borderRadius: '4px',
                  padding: '12px',
                  marginBottom: '15px',
                  fontSize: '13px',
                  color: '#856404'
                }}>
                  It looks like your agency hasn't signed up to FieldWorker yet. Your agency's admin will need to sign up <a style={{ fontSize: 13, color: '#856404' }} href={env === 'prod' ? 'https://fieldworker.ai/signup/' : 'https://staging.fieldworker.ai/signup/'}>here</a> and then invite you to join.
                </div>
              )}

              {!appstate.subscription && (
                <div style={{ 
                  backgroundColor: '#f8d7da', 
                  border: '1px solid #f5c6cb',
                  borderRadius: '4px',
                  padding: '12px',
                  marginBottom: '15px',
                  fontSize: '13px',
                  color: '#721c24'
                }}>
                  No active subscription or account found. Please contact support. Signing out shortly…
                </div>
              )}

              {showRecoverySnackbar && (
                <div style={{ 
                  backgroundColor: '#d4edda', 
                  border: '1px solid #c3e6cb',
                  borderRadius: '4px',
                  padding: '12px',
                  marginBottom: '15px',
                  fontSize: '13px',
                  color: '#155724'
                }}>
                  Details submitted. If your account matches these details, you will receive an email. Please check your inbox.
                </div>
              )}

              {/* Bottom Links */}
              <div style={{ marginTop: 'auto', paddingTop: '10px', borderTop: '1px solid #eee' }}>
                <div style={{ fontSize: '13px', color: '#666', textAlign: 'center' }}>
                  <div style={{ marginBottom: '8px' }}>
                    <a href={env === 'prod' ? 'https://fieldworker.ai/signup/' : 'https://staging.fieldworker.ai/signup/'} style={{ color: '#0b61e2', textDecoration: 'none' }}>
                      Register your company
                    </a>
                    <span style={{ margin: '0 8px', color: '#ddd' }}>|</span>
                    <a href="https://passwordreset.microsoftonline.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#0b61e2', textDecoration: 'none' }}>
                      Request access
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Utilities & Support */}
            <div style={{ 
              backgroundColor: 'white',
              borderRadius: '12px',
              padding: '40px',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              flex: 1,
              minWidth: '400px'
            }}>
              <h2 style={{ fontSize: '28px', fontWeight: '600', marginBottom: '30px', color: '#333', textAlign: 'center' }}>
                Utilities & Support
              </h2>

              <div className="utility-content-grid">
                <div className="utility-actions-column">
                  {/* User Documentation */}
                  <a href="https://fieldworker.gitbook.io/fieldworker-docs" target="_blank" rel="noopener noreferrer" className="utility-link">
                    <div className="utility-item">
                      <i className="fas fa-book"></i>
                      <span>User Documentation</span>
                    </div>
                  </a>

                  {/* Field Apps */}
                  <a href="/app" target="_blank" rel="noopener noreferrer" className="utility-link">
                    <div className="utility-item">
                      <i className="fas fa-mobile-alt"></i>
                      <span>Fieldworker Apps</span>
                    </div>
                  </a>

                  {/* Cures Act Compliance */}
                  <a href="https://compliancy-group.com/compliance-monitoring-dashboard" target="_blank" rel="noopener noreferrer" className="utility-link">
                    <div className="utility-item">
                      <i className="fas fa-shield-alt"></i>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
                        <span>Cures Act Compliance</span>
                        <span style={{ 
                          backgroundColor: '#d4edda', 
                          color: '#155724',
                          padding: '2px 8px',
                          borderRadius: '4px',
                          fontSize: '12px',
                          border: '1px solid #c3e6cb'
                        }}>Verified</span>
                      </div>
                    </div>
                  </a>

                  {/* System Status */}
                  <button
                    type="button"
                    className="utility-item utility-status-button"
                    onClick={() => setShowSystemStatus(true)}
                    aria-haspopup="dialog"
                  >
                    <i className="fas fa-info-circle"></i>
                    <span>System Status</span>
                    <span className="utility-status-indicator">
                      <span className="system-status-dot" aria-hidden="true"></span>
                      Operational
                    </span>
                  </button>
                </div>

                <div className="utility-side-column">
                  <a href="/app" target="_blank" rel="noopener noreferrer" className="utility-qr-link">
                    <img src="/mobile_app_qr_code_dev.jpg" alt="Download App" className="utility-qr-code" />
                    <span>Fieldworker Mobile App</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{ 
          backgroundColor: 'white',
          padding: '20px 40px',
          textAlign: 'center',
          fontSize: '13px',
          color: '#666',
          borderTop: '1px solid #eee'
        }}>
          Copyright © FieldWorker | <a href="https://fieldworker.ai/termsandconditions/" style={{ color: '#666', textDecoration: 'none' }}>Terms & Conditions</a> | <a href="https://fieldworker.ai/privacy-policy/" style={{ color: '#666', textDecoration: 'none' }}>Privacy Policy</a>
        </div>
      </div>
    )
  } else {
    return (<div></div>)
  }
}

export default Landing;
